import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    TextField,
    Button,
    Stack,
    CircularProgress,
    Alert,
    Container,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { auth, db } from './firebaseConfig';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import AuthCard from './AuthCard'; // Import the AuthCard component

const EditProfile = () => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [userData, setUserData] = useState({
        firstName: '',
        lastName: '',
    });
    const navigate = useNavigate();

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const userDoc = doc(db, 'users', auth.currentUser.uid);
                const userSnapshot = await getDoc(userDoc);
                if (userSnapshot.exists()) {
                    setUserData(userSnapshot.data());
                }
                setLoading(false);
            } catch (err) {
                console.error('Error fetching user data:', err);
                setError('Failed to load user data.');
                setLoading(false);
            }
        };

        fetchUserData();
    }, []);

    const handleSaveChanges = async () => {
        try {
            const userDoc = doc(db, 'users', auth.currentUser.uid);
            await updateDoc(userDoc, {
                firstName: userData.firstName,
                lastName: userData.lastName,
            });
            alert('Profile updated successfully!');
            navigate('/home');
        } catch (err) {
            console.error('Error updating profile:', err);
            setError('Failed to save changes.');
        }
    };

    if (loading) {
        return (
            <Box
                display='flex'
                justifyContent='center'
                alignItems='center'
                sx={{ height: '100vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: 'calc(100vh - 128px)', // Account for header (64px) and footer (64px)
                padding: 2,
            }}>
            <Container maxWidth='sm'>
                <AuthCard
                    title='Edit Profile'
                    subtitle='Update your personal information'>
                    {error && <Alert severity='error'>{error}</Alert>}
                    <Stack spacing={3} sx={{ mt: 2 }}>
                        <TextField
                            label='First Name'
                            value={userData.firstName || ''}
                            onChange={(e) =>
                                setUserData({
                                    ...userData,
                                    firstName: e.target.value,
                                })
                            }
                            placeholder='Enter your first name'
                            fullWidth
                        />
                        <TextField
                            label='Last Name'
                            value={userData.lastName || ''}
                            onChange={(e) =>
                                setUserData({
                                    ...userData,
                                    lastName: e.target.value,
                                })
                            }
                            placeholder='Enter your last name'
                            fullWidth
                        />
                        <Button
                            variant='contained'
                            fullWidth
                            onClick={handleSaveChanges}
                            sx={{
                                backgroundColor: '#10B981',
                                '&:hover': {
                                    backgroundColor: '#0D8F6E',
                                },
                                textTransform: 'none',
                                fontSize: '1rem',
                                fontWeight: 500,
                                padding: '12px 24px',
                                borderRadius: '12px',
                            }}>
                            Save Changes
                        </Button>
                        <Button
                            variant='outlined'
                            fullWidth
                            onClick={() => navigate('/home')}
                            sx={{
                                borderColor: '#E2E8F0',
                                color: '#64748B',
                                textTransform: 'none',
                                fontSize: '1rem',
                                fontWeight: 500,
                                padding: '12px 24px',
                                borderRadius: '12px',
                                '&:hover': {
                                    borderColor: '#CBD5E1',
                                },
                            }}>
                            Cancel
                        </Button>
                    </Stack>
                </AuthCard>
            </Container>
        </Box>
    );
};

export default EditProfile;
